<template>
    <span class="el-stencil ath-visual-rating" style="width: 12.8rem;height: 2rem"></span>
</template>

<script>
export default {
    name: 'mead-rating-stencil',
};
</script>
